export const removefileFromFilesResponses = (filesForResponse, fileNameToRemove) => {
  if (!Array.isArray(filesForResponse) || !fileNameToRemove) return []
  const newFiles = [...filesForResponse]
  const indexToRemove = newFiles.findIndex(file => file?.fileName === fileNameToRemove)
  if (indexToRemove !== -1) newFiles.splice(indexToRemove)
  return newFiles
}
